module.exports = __webpack_public_path__ + "static/media/Laughing – 1.31ec3053.jpg";